import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar-menu"
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = {
    open: { type: Boolean, default: false },
    key: String
  }

  connect() {
    // Restore state from localStorage
    if (this.hasKeyValue) {
      const stored = localStorage.getItem(`sidebar-menu-${this.keyValue}`)
      if (stored !== null) {
        this.openValue = stored === "true"
      }
    }

    // Check if any child is active - if so, expand
    if (this.hasContentTarget) {
      const hasActiveChild = this.contentTarget.querySelector('.bg-emerald-900\\/50')
      if (hasActiveChild) {
        this.openValue = true
      }
    }

    this.updateDisplay()
  }

  toggle() {
    this.openValue = !this.openValue
    this.updateDisplay()

    // Save state to localStorage
    if (this.hasKeyValue) {
      localStorage.setItem(`sidebar-menu-${this.keyValue}`, this.openValue)
    }
  }

  updateDisplay() {
    if (this.hasContentTarget) {
      if (this.openValue) {
        this.contentTarget.classList.remove("hidden")
      } else {
        this.contentTarget.classList.add("hidden")
      }
    }

    if (this.hasIconTarget) {
      if (this.openValue) {
        this.iconTarget.classList.add("rotate-90")
      } else {
        this.iconTarget.classList.remove("rotate-90")
      }
    }
  }
}
